import { handleActions } from 'redux-actions';
import { loop, Cmd } from 'redux-loop';

import authActions from '../action/auth';
import { authDoPendingActionsCommand, authInitCommand } from '../command/auth';

export { default as Actions } from '../action/auth';

export const base = 'auth';

export const defaultState = {
  isAuthenticated: false,
  isLoading: false,
  role: null,
  token: null,
  user: null,
};

export const selector_auth = ({ auth }) => auth;

export default () =>
  handleActions(
    {
      [authActions.init](state, { payload }) {
        return loop(
          { ...state, isLoading: true },
          Cmd.run(authInitCommand, {
            successActionCreator: authActions.store,
            args: [payload],
          })
        );
      },
      [authActions.store](state, { payload }) {
        const { isAuthenticated, role, token, user } = payload;
        return loop(
          {
            ...state,
            isAuthenticated,
            isLoading: false,
            role,
            token,
            user,
          },
          Cmd.run(authDoPendingActionsCommand, {
            args: [Cmd.dispatch, isAuthenticated],
          })
        );
      },
    },
    defaultState
  );
